

  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >{{ modalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:30px;">
            <div>
                <p>
                    {{ modalContent }}
                </p>
            </div>
            <br/>
            <div>
                <button class="button button-red btn-middle" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>